import { render, staticRenderFns } from "./AvailabilityTopnavContent.vue?vue&type=template&id=4b5169ae&scoped=true"
import script from "./AvailabilityTopnavContent.vue?vue&type=script&lang=js"
export * from "./AvailabilityTopnavContent.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityTopnavContent.vue?vue&type=style&index=0&id=4b5169ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5169ae",
  null
  
)

export default component.exports